import React, { FC, useCallback } from "react"
import { useDispatch } from "react-redux"
import { userSignUp } from "../../../../Actions/Auth/AuthActions"
import { MainThunkDispatch } from "../../../../Reducers"
import {
    EmailAndPasswordInputRenderContainer,
    FormData
} from "../EmailAndPasswordInputRenderContainer/EmailAndPasswordInputRenderContainer"
import { safePromise } from "../../../../Helpers/Functions/promise"

interface SignupFormProps {
    prefilledEmail?: string
    onLoginSuccess?: () => void
    squashSuccessMessage: boolean
}

export const SignupForm: FC<SignupFormProps> = ({
    prefilledEmail,
    onLoginSuccess,
    squashSuccessMessage
}) => {
    const dispatch = useDispatch<MainThunkDispatch>()
    const handleSignup = useCallback(
        async ({ email, password }: FormData) => {
            const { data, error } = await safePromise(
                dispatch(userSignUp(email, password, squashSuccessMessage))
            )

            if (error !== undefined) {
                throw error
            }
            // if signup resulted in successful login
            if (data === true && onLoginSuccess !== undefined) {
                onLoginSuccess()
            }
        },
        [dispatch, onLoginSuccess, squashSuccessMessage]
    )

    return (
        <EmailAndPasswordInputRenderContainer
            testId="signup-form"
            onSubmit={handleSignup}
            submitLabel="Sign Up"
            emailLabel="Work email"
            passwordLabel="Choose a password"
            prefilledEmail={prefilledEmail}
            disablePasswordPatternValidation={false}
        />
    )
}
